import { useCallback } from 'react';
import debounce from 'hs-lodash/debounce';
export function useDebounce(functionToDebounce, delay) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(debounce(functionToDebounce, delay), []);
}